/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as SuperadminRouteImport } from './routes/superadmin'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as JoinRouteImport } from './routes/join'
import { Route as HelpRouteImport } from './routes/help'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as CreateOrgRouteImport } from './routes/create-org'
import { Route as AccountRouteImport } from './routes/account'
import { Route as MapSlugRouteImport } from './routes/$mapSlug'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SuperadminIndexRouteImport } from './routes/superadmin.index'
import { Route as SuperadminThemesRouteImport } from './routes/superadmin.themes'
import { Route as SuperadminSupportRouteImport } from './routes/superadmin.support'
import { Route as SuperadminSecurityLogsRouteImport } from './routes/superadmin.security-logs'
import { Route as SuperadminReportsRouteImport } from './routes/superadmin.reports'
import { Route as SuperadminPromoteAssetsRouteImport } from './routes/superadmin.promote-assets'
import { Route as SuperadminOrgsRouteImport } from './routes/superadmin.orgs'
import { Route as SuperadminOnboardingRouteImport } from './routes/superadmin.onboarding'
import { Route as SuperadminMapScannerRouteImport } from './routes/superadmin.map-scanner'
import { Route as SuperadminFeatureFlagsRouteImport } from './routes/superadmin.feature-flags'
import { Route as SuperadminEngagementReportsRouteImport } from './routes/superadmin.engagement-reports'
import { Route as SuperadminAuditLogRouteImport } from './routes/superadmin.audit-log'
import { Route as SuperadminA11yRouteImport } from './routes/superadmin.a11y'
import { Route as OrgSlugAdminRouteImport } from './routes/$orgSlug.admin'
import { Route as OrgSlugMapSlugRouteImport } from './routes/$orgSlug.$mapSlug'
import { Route as SuperadminSecurityLogsIndexRouteImport } from './routes/superadmin.security-logs.index'
import { Route as SuperadminOrgsIndexRouteImport } from './routes/superadmin.orgs.index'
import { Route as SuperadminFeatureFlagsIndexRouteImport } from './routes/superadmin.feature-flags.index'
import { Route as SuperadminAuditLogIndexRouteImport } from './routes/superadmin.audit-log.index'
import { Route as OrgSlugAdminIndexRouteImport } from './routes/$orgSlug.admin.index'
import { Route as SuperadminThemesThemeIdRouteImport } from './routes/superadmin.themes.$themeId'
import { Route as SuperadminOrgsOrgIdRouteImport } from './routes/superadmin.orgs.$orgId'
import { Route as SuperadminFeatureFlagsNewRouteImport } from './routes/superadmin.feature-flags.new'
import { Route as SuperadminFeatureFlagsFlagIdRouteImport } from './routes/superadmin.feature-flags.$flagId'
import { Route as OrgSlugAdminTeamRouteImport } from './routes/$orgSlug.admin.team'
import { Route as OrgSlugAdminTagsRouteImport } from './routes/$orgSlug.admin.tags'
import { Route as OrgSlugAdminSettingsRouteImport } from './routes/$orgSlug.admin.settings'
import { Route as OrgSlugAdminQrCodesRouteImport } from './routes/$orgSlug.admin.qr-codes'
import { Route as OrgSlugAdminPromoteRouteImport } from './routes/$orgSlug.admin.promote'
import { Route as OrgSlugAdminPoisRouteImport } from './routes/$orgSlug.admin.pois'
import { Route as OrgSlugAdminNotificationsRouteImport } from './routes/$orgSlug.admin.notifications'
import { Route as OrgSlugAdminMapsRouteImport } from './routes/$orgSlug.admin.maps'
import { Route as OrgSlugAdminIngestRouteImport } from './routes/$orgSlug.admin.ingest'
import { Route as OrgSlugAdminFeedbackRouteImport } from './routes/$orgSlug.admin.feedback'
import { Route as OrgSlugAdminEventsRouteImport } from './routes/$orgSlug.admin.events'
import { Route as OrgSlugAdminCuratedListsRouteImport } from './routes/$orgSlug.admin.curated-lists'
import { Route as OrgSlugAdminCategoriesRouteImport } from './routes/$orgSlug.admin.categories'
import { Route as OrgSlugAdminAuditLogRouteImport } from './routes/$orgSlug.admin.audit-log'
import { Route as OrgSlugAdminAnnouncementsRouteImport } from './routes/$orgSlug.admin.announcements'
import { Route as OrgSlugAdminAnalyticsRouteImport } from './routes/$orgSlug.admin.analytics'
import { Route as SuperadminThemesBaseSlugRouteImport } from './routes/superadmin.themes.base.$slug'
import { Route as OrgSlugAdminSettingsVisitorMenuRouteImport } from './routes/$orgSlug.admin.settings.visitor-menu'
import { Route as OrgSlugAdminSettingsSocialLinksRouteImport } from './routes/$orgSlug.admin.settings.social-links'
import { Route as OrgSlugAdminSettingsQuickLinksRouteImport } from './routes/$orgSlug.admin.settings.quick-links'
import { Route as OrgSlugAdminSettingsFaqRouteImport } from './routes/$orgSlug.admin.settings.faq'
import { Route as OrgSlugAdminSettingsDomainsRouteImport } from './routes/$orgSlug.admin.settings.domains'
import { Route as OrgSlugAdminSettingsBrandingRouteImport } from './routes/$orgSlug.admin.settings.branding'
import { Route as OrgSlugAdminSettingsBillingRouteImport } from './routes/$orgSlug.admin.settings.billing'
import { Route as OrgSlugAdminPromoteSponsorsRouteImport } from './routes/$orgSlug.admin.promote.sponsors'
import { Route as OrgSlugAdminPromoteShareEmbedRouteImport } from './routes/$orgSlug.admin.promote.share-embed'
import { Route as OrgSlugAdminPromoteQrCodesRouteImport } from './routes/$orgSlug.admin.promote.qr-codes'
import { Route as OrgSlugAdminPromoteMarketingRouteImport } from './routes/$orgSlug.admin.promote.marketing'
import { Route as OrgSlugAdminPromoteGuidesRouteImport } from './routes/$orgSlug.admin.promote.guides'
import { Route as OrgSlugAdminPromoteAssetsRouteImport } from './routes/$orgSlug.admin.promote.assets'
import { Route as OrgSlugAdminMapMapSlugRouteImport } from './routes/$orgSlug.admin.map.$mapSlug'
import { Route as OrgSlugAdminMapMapSlugTagsRouteImport } from './routes/$orgSlug.admin.map.$mapSlug.tags'
import { Route as OrgSlugAdminMapMapSlugPlacePoisRouteImport } from './routes/$orgSlug.admin.map.$mapSlug.place-pois'

const HelpIndexLazyRouteImport = createFileRoute('/help/')()
const HelpSectionLazyRouteImport = createFileRoute('/help/$section')()

const SuperadminRoute = SuperadminRouteImport.update({
  id: '/superadmin',
  path: '/superadmin',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinRoute = JoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpRoute = HelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/help.lazy').then((d) => d.Route))
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const CreateOrgRoute = CreateOrgRouteImport.update({
  id: '/create-org',
  path: '/create-org',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const MapSlugRoute = MapSlugRouteImport.update({
  id: '/$mapSlug',
  path: '/$mapSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpIndexLazyRoute = HelpIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HelpRoute,
} as any).lazy(() => import('./routes/help.index.lazy').then((d) => d.Route))
const SuperadminIndexRoute = SuperadminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SuperadminRoute,
} as any)
const HelpSectionLazyRoute = HelpSectionLazyRouteImport.update({
  id: '/$section',
  path: '/$section',
  getParentRoute: () => HelpRoute,
} as any).lazy(() => import('./routes/help.$section.lazy').then((d) => d.Route))
const SuperadminThemesRoute = SuperadminThemesRouteImport.update({
  id: '/themes',
  path: '/themes',
  getParentRoute: () => SuperadminRoute,
} as any).lazy(() =>
  import('./routes/superadmin.themes.lazy').then((d) => d.Route),
)
const SuperadminSupportRoute = SuperadminSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => SuperadminRoute,
} as any)
const SuperadminSecurityLogsRoute = SuperadminSecurityLogsRouteImport.update({
  id: '/security-logs',
  path: '/security-logs',
  getParentRoute: () => SuperadminRoute,
} as any)
const SuperadminReportsRoute = SuperadminReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => SuperadminRoute,
} as any)
const SuperadminPromoteAssetsRoute = SuperadminPromoteAssetsRouteImport.update({
  id: '/promote-assets',
  path: '/promote-assets',
  getParentRoute: () => SuperadminRoute,
} as any).lazy(() =>
  import('./routes/superadmin.promote-assets.lazy').then((d) => d.Route),
)
const SuperadminOrgsRoute = SuperadminOrgsRouteImport.update({
  id: '/orgs',
  path: '/orgs',
  getParentRoute: () => SuperadminRoute,
} as any)
const SuperadminOnboardingRoute = SuperadminOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => SuperadminRoute,
} as any)
const SuperadminMapScannerRoute = SuperadminMapScannerRouteImport.update({
  id: '/map-scanner',
  path: '/map-scanner',
  getParentRoute: () => SuperadminRoute,
} as any).lazy(() =>
  import('./routes/superadmin.map-scanner.lazy').then((d) => d.Route),
)
const SuperadminFeatureFlagsRoute = SuperadminFeatureFlagsRouteImport.update({
  id: '/feature-flags',
  path: '/feature-flags',
  getParentRoute: () => SuperadminRoute,
} as any)
const SuperadminEngagementReportsRoute =
  SuperadminEngagementReportsRouteImport.update({
    id: '/engagement-reports',
    path: '/engagement-reports',
    getParentRoute: () => SuperadminRoute,
  } as any)
const SuperadminAuditLogRoute = SuperadminAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => SuperadminRoute,
} as any)
const SuperadminA11yRoute = SuperadminA11yRouteImport.update({
  id: '/a11y',
  path: '/a11y',
  getParentRoute: () => SuperadminRoute,
} as any).lazy(() =>
  import('./routes/superadmin.a11y.lazy').then((d) => d.Route),
)
const OrgSlugAdminRoute = OrgSlugAdminRouteImport.update({
  id: '/$orgSlug/admin',
  path: '/$orgSlug/admin',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/$orgSlug.admin.lazy').then((d) => d.Route),
)
const OrgSlugMapSlugRoute = OrgSlugMapSlugRouteImport.update({
  id: '/$orgSlug/$mapSlug',
  path: '/$orgSlug/$mapSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const SuperadminSecurityLogsIndexRoute =
  SuperadminSecurityLogsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SuperadminSecurityLogsRoute,
  } as any)
const SuperadminOrgsIndexRoute = SuperadminOrgsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SuperadminOrgsRoute,
} as any)
const SuperadminFeatureFlagsIndexRoute =
  SuperadminFeatureFlagsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SuperadminFeatureFlagsRoute,
  } as any)
const SuperadminAuditLogIndexRoute = SuperadminAuditLogIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SuperadminAuditLogRoute,
} as any)
const OrgSlugAdminIndexRoute = OrgSlugAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrgSlugAdminRoute,
} as any).lazy(() =>
  import('./routes/$orgSlug.admin.index.lazy').then((d) => d.Route),
)
const SuperadminThemesThemeIdRoute = SuperadminThemesThemeIdRouteImport.update({
  id: '/$themeId',
  path: '/$themeId',
  getParentRoute: () => SuperadminThemesRoute,
} as any).lazy(() =>
  import('./routes/superadmin.themes.$themeId.lazy').then((d) => d.Route),
)
const SuperadminOrgsOrgIdRoute = SuperadminOrgsOrgIdRouteImport.update({
  id: '/$orgId',
  path: '/$orgId',
  getParentRoute: () => SuperadminOrgsRoute,
} as any).lazy(() =>
  import('./routes/superadmin.orgs.$orgId.lazy').then((d) => d.Route),
)
const SuperadminFeatureFlagsNewRoute =
  SuperadminFeatureFlagsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => SuperadminFeatureFlagsRoute,
  } as any).lazy(() =>
    import('./routes/superadmin.feature-flags.new.lazy').then((d) => d.Route),
  )
const SuperadminFeatureFlagsFlagIdRoute =
  SuperadminFeatureFlagsFlagIdRouteImport.update({
    id: '/$flagId',
    path: '/$flagId',
    getParentRoute: () => SuperadminFeatureFlagsRoute,
  } as any).lazy(() =>
    import('./routes/superadmin.feature-flags.$flagId.lazy').then(
      (d) => d.Route,
    ),
  )
const OrgSlugAdminTeamRoute = OrgSlugAdminTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => OrgSlugAdminRoute,
} as any).lazy(() =>
  import('./routes/$orgSlug.admin.team.lazy').then((d) => d.Route),
)
const OrgSlugAdminTagsRoute = OrgSlugAdminTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => OrgSlugAdminRoute,
} as any).lazy(() =>
  import('./routes/$orgSlug.admin.tags.lazy').then((d) => d.Route),
)
const OrgSlugAdminSettingsRoute = OrgSlugAdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => OrgSlugAdminRoute,
} as any)
const OrgSlugAdminQrCodesRoute = OrgSlugAdminQrCodesRouteImport.update({
  id: '/qr-codes',
  path: '/qr-codes',
  getParentRoute: () => OrgSlugAdminRoute,
} as any)
const OrgSlugAdminPromoteRoute = OrgSlugAdminPromoteRouteImport.update({
  id: '/promote',
  path: '/promote',
  getParentRoute: () => OrgSlugAdminRoute,
} as any)
const OrgSlugAdminPoisRoute = OrgSlugAdminPoisRouteImport.update({
  id: '/pois',
  path: '/pois',
  getParentRoute: () => OrgSlugAdminRoute,
} as any).lazy(() =>
  import('./routes/$orgSlug.admin.pois.lazy').then((d) => d.Route),
)
const OrgSlugAdminNotificationsRoute =
  OrgSlugAdminNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => OrgSlugAdminRoute,
  } as any).lazy(() =>
    import('./routes/$orgSlug.admin.notifications.lazy').then((d) => d.Route),
  )
const OrgSlugAdminMapsRoute = OrgSlugAdminMapsRouteImport.update({
  id: '/maps',
  path: '/maps',
  getParentRoute: () => OrgSlugAdminRoute,
} as any).lazy(() =>
  import('./routes/$orgSlug.admin.maps.lazy').then((d) => d.Route),
)
const OrgSlugAdminIngestRoute = OrgSlugAdminIngestRouteImport.update({
  id: '/ingest',
  path: '/ingest',
  getParentRoute: () => OrgSlugAdminRoute,
} as any).lazy(() =>
  import('./routes/$orgSlug.admin.ingest.lazy').then((d) => d.Route),
)
const OrgSlugAdminFeedbackRoute = OrgSlugAdminFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => OrgSlugAdminRoute,
} as any).lazy(() =>
  import('./routes/$orgSlug.admin.feedback.lazy').then((d) => d.Route),
)
const OrgSlugAdminEventsRoute = OrgSlugAdminEventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => OrgSlugAdminRoute,
} as any).lazy(() =>
  import('./routes/$orgSlug.admin.events.lazy').then((d) => d.Route),
)
const OrgSlugAdminCuratedListsRoute =
  OrgSlugAdminCuratedListsRouteImport.update({
    id: '/curated-lists',
    path: '/curated-lists',
    getParentRoute: () => OrgSlugAdminRoute,
  } as any).lazy(() =>
    import('./routes/$orgSlug.admin.curated-lists.lazy').then((d) => d.Route),
  )
const OrgSlugAdminCategoriesRoute = OrgSlugAdminCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => OrgSlugAdminRoute,
} as any).lazy(() =>
  import('./routes/$orgSlug.admin.categories.lazy').then((d) => d.Route),
)
const OrgSlugAdminAuditLogRoute = OrgSlugAdminAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => OrgSlugAdminRoute,
} as any).lazy(() =>
  import('./routes/$orgSlug.admin.audit-log.lazy').then((d) => d.Route),
)
const OrgSlugAdminAnnouncementsRoute =
  OrgSlugAdminAnnouncementsRouteImport.update({
    id: '/announcements',
    path: '/announcements',
    getParentRoute: () => OrgSlugAdminRoute,
  } as any)
const OrgSlugAdminAnalyticsRoute = OrgSlugAdminAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => OrgSlugAdminRoute,
} as any).lazy(() =>
  import('./routes/$orgSlug.admin.analytics.lazy').then((d) => d.Route),
)
const SuperadminThemesBaseSlugRoute =
  SuperadminThemesBaseSlugRouteImport.update({
    id: '/base/$slug',
    path: '/base/$slug',
    getParentRoute: () => SuperadminThemesRoute,
  } as any).lazy(() =>
    import('./routes/superadmin.themes.base.$slug.lazy').then((d) => d.Route),
  )
const OrgSlugAdminSettingsVisitorMenuRoute =
  OrgSlugAdminSettingsVisitorMenuRouteImport.update({
    id: '/visitor-menu',
    path: '/visitor-menu',
    getParentRoute: () => OrgSlugAdminSettingsRoute,
  } as any)
const OrgSlugAdminSettingsSocialLinksRoute =
  OrgSlugAdminSettingsSocialLinksRouteImport.update({
    id: '/social-links',
    path: '/social-links',
    getParentRoute: () => OrgSlugAdminSettingsRoute,
  } as any).lazy(() =>
    import('./routes/$orgSlug.admin.settings.social-links.lazy').then(
      (d) => d.Route,
    ),
  )
const OrgSlugAdminSettingsQuickLinksRoute =
  OrgSlugAdminSettingsQuickLinksRouteImport.update({
    id: '/quick-links',
    path: '/quick-links',
    getParentRoute: () => OrgSlugAdminSettingsRoute,
  } as any).lazy(() =>
    import('./routes/$orgSlug.admin.settings.quick-links.lazy').then(
      (d) => d.Route,
    ),
  )
const OrgSlugAdminSettingsFaqRoute = OrgSlugAdminSettingsFaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => OrgSlugAdminSettingsRoute,
} as any).lazy(() =>
  import('./routes/$orgSlug.admin.settings.faq.lazy').then((d) => d.Route),
)
const OrgSlugAdminSettingsDomainsRoute =
  OrgSlugAdminSettingsDomainsRouteImport.update({
    id: '/domains',
    path: '/domains',
    getParentRoute: () => OrgSlugAdminSettingsRoute,
  } as any).lazy(() =>
    import('./routes/$orgSlug.admin.settings.domains.lazy').then(
      (d) => d.Route,
    ),
  )
const OrgSlugAdminSettingsBrandingRoute =
  OrgSlugAdminSettingsBrandingRouteImport.update({
    id: '/branding',
    path: '/branding',
    getParentRoute: () => OrgSlugAdminSettingsRoute,
  } as any).lazy(() =>
    import('./routes/$orgSlug.admin.settings.branding.lazy').then(
      (d) => d.Route,
    ),
  )
const OrgSlugAdminSettingsBillingRoute =
  OrgSlugAdminSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => OrgSlugAdminSettingsRoute,
  } as any).lazy(() =>
    import('./routes/$orgSlug.admin.settings.billing.lazy').then(
      (d) => d.Route,
    ),
  )
const OrgSlugAdminPromoteSponsorsRoute =
  OrgSlugAdminPromoteSponsorsRouteImport.update({
    id: '/sponsors',
    path: '/sponsors',
    getParentRoute: () => OrgSlugAdminPromoteRoute,
  } as any).lazy(() =>
    import('./routes/$orgSlug.admin.promote.sponsors.lazy').then(
      (d) => d.Route,
    ),
  )
const OrgSlugAdminPromoteShareEmbedRoute =
  OrgSlugAdminPromoteShareEmbedRouteImport.update({
    id: '/share-embed',
    path: '/share-embed',
    getParentRoute: () => OrgSlugAdminPromoteRoute,
  } as any).lazy(() =>
    import('./routes/$orgSlug.admin.promote.share-embed.lazy').then(
      (d) => d.Route,
    ),
  )
const OrgSlugAdminPromoteQrCodesRoute =
  OrgSlugAdminPromoteQrCodesRouteImport.update({
    id: '/qr-codes',
    path: '/qr-codes',
    getParentRoute: () => OrgSlugAdminPromoteRoute,
  } as any).lazy(() =>
    import('./routes/$orgSlug.admin.promote.qr-codes.lazy').then(
      (d) => d.Route,
    ),
  )
const OrgSlugAdminPromoteMarketingRoute =
  OrgSlugAdminPromoteMarketingRouteImport.update({
    id: '/marketing',
    path: '/marketing',
    getParentRoute: () => OrgSlugAdminPromoteRoute,
  } as any).lazy(() =>
    import('./routes/$orgSlug.admin.promote.marketing.lazy').then(
      (d) => d.Route,
    ),
  )
const OrgSlugAdminPromoteGuidesRoute =
  OrgSlugAdminPromoteGuidesRouteImport.update({
    id: '/guides',
    path: '/guides',
    getParentRoute: () => OrgSlugAdminPromoteRoute,
  } as any).lazy(() =>
    import('./routes/$orgSlug.admin.promote.guides.lazy').then((d) => d.Route),
  )
const OrgSlugAdminPromoteAssetsRoute =
  OrgSlugAdminPromoteAssetsRouteImport.update({
    id: '/assets',
    path: '/assets',
    getParentRoute: () => OrgSlugAdminPromoteRoute,
  } as any).lazy(() =>
    import('./routes/$orgSlug.admin.promote.assets.lazy').then((d) => d.Route),
  )
const OrgSlugAdminMapMapSlugRoute = OrgSlugAdminMapMapSlugRouteImport.update({
  id: '/map/$mapSlug',
  path: '/map/$mapSlug',
  getParentRoute: () => OrgSlugAdminRoute,
} as any).lazy(() =>
  import('./routes/$orgSlug.admin.map.$mapSlug.lazy').then((d) => d.Route),
)
const OrgSlugAdminMapMapSlugTagsRoute =
  OrgSlugAdminMapMapSlugTagsRouteImport.update({
    id: '/tags',
    path: '/tags',
    getParentRoute: () => OrgSlugAdminMapMapSlugRoute,
  } as any).lazy(() =>
    import('./routes/$orgSlug.admin.map.$mapSlug.tags.lazy').then(
      (d) => d.Route,
    ),
  )
const OrgSlugAdminMapMapSlugPlacePoisRoute =
  OrgSlugAdminMapMapSlugPlacePoisRouteImport.update({
    id: '/place-pois',
    path: '/place-pois',
    getParentRoute: () => OrgSlugAdminMapMapSlugRoute,
  } as any).lazy(() =>
    import('./routes/$orgSlug.admin.map.$mapSlug.place-pois.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$mapSlug': typeof MapSlugRoute
  '/account': typeof AccountRoute
  '/create-org': typeof CreateOrgRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/help': typeof HelpRouteWithChildren
  '/join': typeof JoinRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/superadmin': typeof SuperadminRouteWithChildren
  '/$orgSlug/$mapSlug': typeof OrgSlugMapSlugRoute
  '/$orgSlug/admin': typeof OrgSlugAdminRouteWithChildren
  '/superadmin/a11y': typeof SuperadminA11yRoute
  '/superadmin/audit-log': typeof SuperadminAuditLogRouteWithChildren
  '/superadmin/engagement-reports': typeof SuperadminEngagementReportsRoute
  '/superadmin/feature-flags': typeof SuperadminFeatureFlagsRouteWithChildren
  '/superadmin/map-scanner': typeof SuperadminMapScannerRoute
  '/superadmin/onboarding': typeof SuperadminOnboardingRoute
  '/superadmin/orgs': typeof SuperadminOrgsRouteWithChildren
  '/superadmin/promote-assets': typeof SuperadminPromoteAssetsRoute
  '/superadmin/reports': typeof SuperadminReportsRoute
  '/superadmin/security-logs': typeof SuperadminSecurityLogsRouteWithChildren
  '/superadmin/support': typeof SuperadminSupportRoute
  '/superadmin/themes': typeof SuperadminThemesRouteWithChildren
  '/help/$section': typeof HelpSectionLazyRoute
  '/superadmin/': typeof SuperadminIndexRoute
  '/help/': typeof HelpIndexLazyRoute
  '/$orgSlug/admin/analytics': typeof OrgSlugAdminAnalyticsRoute
  '/$orgSlug/admin/announcements': typeof OrgSlugAdminAnnouncementsRoute
  '/$orgSlug/admin/audit-log': typeof OrgSlugAdminAuditLogRoute
  '/$orgSlug/admin/categories': typeof OrgSlugAdminCategoriesRoute
  '/$orgSlug/admin/curated-lists': typeof OrgSlugAdminCuratedListsRoute
  '/$orgSlug/admin/events': typeof OrgSlugAdminEventsRoute
  '/$orgSlug/admin/feedback': typeof OrgSlugAdminFeedbackRoute
  '/$orgSlug/admin/ingest': typeof OrgSlugAdminIngestRoute
  '/$orgSlug/admin/maps': typeof OrgSlugAdminMapsRoute
  '/$orgSlug/admin/notifications': typeof OrgSlugAdminNotificationsRoute
  '/$orgSlug/admin/pois': typeof OrgSlugAdminPoisRoute
  '/$orgSlug/admin/promote': typeof OrgSlugAdminPromoteRouteWithChildren
  '/$orgSlug/admin/qr-codes': typeof OrgSlugAdminQrCodesRoute
  '/$orgSlug/admin/settings': typeof OrgSlugAdminSettingsRouteWithChildren
  '/$orgSlug/admin/tags': typeof OrgSlugAdminTagsRoute
  '/$orgSlug/admin/team': typeof OrgSlugAdminTeamRoute
  '/superadmin/feature-flags/$flagId': typeof SuperadminFeatureFlagsFlagIdRoute
  '/superadmin/feature-flags/new': typeof SuperadminFeatureFlagsNewRoute
  '/superadmin/orgs/$orgId': typeof SuperadminOrgsOrgIdRoute
  '/superadmin/themes/$themeId': typeof SuperadminThemesThemeIdRoute
  '/$orgSlug/admin/': typeof OrgSlugAdminIndexRoute
  '/superadmin/audit-log/': typeof SuperadminAuditLogIndexRoute
  '/superadmin/feature-flags/': typeof SuperadminFeatureFlagsIndexRoute
  '/superadmin/orgs/': typeof SuperadminOrgsIndexRoute
  '/superadmin/security-logs/': typeof SuperadminSecurityLogsIndexRoute
  '/$orgSlug/admin/map/$mapSlug': typeof OrgSlugAdminMapMapSlugRouteWithChildren
  '/$orgSlug/admin/promote/assets': typeof OrgSlugAdminPromoteAssetsRoute
  '/$orgSlug/admin/promote/guides': typeof OrgSlugAdminPromoteGuidesRoute
  '/$orgSlug/admin/promote/marketing': typeof OrgSlugAdminPromoteMarketingRoute
  '/$orgSlug/admin/promote/qr-codes': typeof OrgSlugAdminPromoteQrCodesRoute
  '/$orgSlug/admin/promote/share-embed': typeof OrgSlugAdminPromoteShareEmbedRoute
  '/$orgSlug/admin/promote/sponsors': typeof OrgSlugAdminPromoteSponsorsRoute
  '/$orgSlug/admin/settings/billing': typeof OrgSlugAdminSettingsBillingRoute
  '/$orgSlug/admin/settings/branding': typeof OrgSlugAdminSettingsBrandingRoute
  '/$orgSlug/admin/settings/domains': typeof OrgSlugAdminSettingsDomainsRoute
  '/$orgSlug/admin/settings/faq': typeof OrgSlugAdminSettingsFaqRoute
  '/$orgSlug/admin/settings/quick-links': typeof OrgSlugAdminSettingsQuickLinksRoute
  '/$orgSlug/admin/settings/social-links': typeof OrgSlugAdminSettingsSocialLinksRoute
  '/$orgSlug/admin/settings/visitor-menu': typeof OrgSlugAdminSettingsVisitorMenuRoute
  '/superadmin/themes/base/$slug': typeof SuperadminThemesBaseSlugRoute
  '/$orgSlug/admin/map/$mapSlug/place-pois': typeof OrgSlugAdminMapMapSlugPlacePoisRoute
  '/$orgSlug/admin/map/$mapSlug/tags': typeof OrgSlugAdminMapMapSlugTagsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$mapSlug': typeof MapSlugRoute
  '/account': typeof AccountRoute
  '/create-org': typeof CreateOrgRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/join': typeof JoinRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/$orgSlug/$mapSlug': typeof OrgSlugMapSlugRoute
  '/superadmin/a11y': typeof SuperadminA11yRoute
  '/superadmin/engagement-reports': typeof SuperadminEngagementReportsRoute
  '/superadmin/map-scanner': typeof SuperadminMapScannerRoute
  '/superadmin/onboarding': typeof SuperadminOnboardingRoute
  '/superadmin/promote-assets': typeof SuperadminPromoteAssetsRoute
  '/superadmin/reports': typeof SuperadminReportsRoute
  '/superadmin/support': typeof SuperadminSupportRoute
  '/superadmin/themes': typeof SuperadminThemesRouteWithChildren
  '/help/$section': typeof HelpSectionLazyRoute
  '/superadmin': typeof SuperadminIndexRoute
  '/help': typeof HelpIndexLazyRoute
  '/$orgSlug/admin/analytics': typeof OrgSlugAdminAnalyticsRoute
  '/$orgSlug/admin/announcements': typeof OrgSlugAdminAnnouncementsRoute
  '/$orgSlug/admin/audit-log': typeof OrgSlugAdminAuditLogRoute
  '/$orgSlug/admin/categories': typeof OrgSlugAdminCategoriesRoute
  '/$orgSlug/admin/curated-lists': typeof OrgSlugAdminCuratedListsRoute
  '/$orgSlug/admin/events': typeof OrgSlugAdminEventsRoute
  '/$orgSlug/admin/feedback': typeof OrgSlugAdminFeedbackRoute
  '/$orgSlug/admin/ingest': typeof OrgSlugAdminIngestRoute
  '/$orgSlug/admin/maps': typeof OrgSlugAdminMapsRoute
  '/$orgSlug/admin/notifications': typeof OrgSlugAdminNotificationsRoute
  '/$orgSlug/admin/pois': typeof OrgSlugAdminPoisRoute
  '/$orgSlug/admin/promote': typeof OrgSlugAdminPromoteRouteWithChildren
  '/$orgSlug/admin/qr-codes': typeof OrgSlugAdminQrCodesRoute
  '/$orgSlug/admin/settings': typeof OrgSlugAdminSettingsRouteWithChildren
  '/$orgSlug/admin/tags': typeof OrgSlugAdminTagsRoute
  '/$orgSlug/admin/team': typeof OrgSlugAdminTeamRoute
  '/superadmin/feature-flags/$flagId': typeof SuperadminFeatureFlagsFlagIdRoute
  '/superadmin/feature-flags/new': typeof SuperadminFeatureFlagsNewRoute
  '/superadmin/orgs/$orgId': typeof SuperadminOrgsOrgIdRoute
  '/superadmin/themes/$themeId': typeof SuperadminThemesThemeIdRoute
  '/$orgSlug/admin': typeof OrgSlugAdminIndexRoute
  '/superadmin/audit-log': typeof SuperadminAuditLogIndexRoute
  '/superadmin/feature-flags': typeof SuperadminFeatureFlagsIndexRoute
  '/superadmin/orgs': typeof SuperadminOrgsIndexRoute
  '/superadmin/security-logs': typeof SuperadminSecurityLogsIndexRoute
  '/$orgSlug/admin/map/$mapSlug': typeof OrgSlugAdminMapMapSlugRouteWithChildren
  '/$orgSlug/admin/promote/assets': typeof OrgSlugAdminPromoteAssetsRoute
  '/$orgSlug/admin/promote/guides': typeof OrgSlugAdminPromoteGuidesRoute
  '/$orgSlug/admin/promote/marketing': typeof OrgSlugAdminPromoteMarketingRoute
  '/$orgSlug/admin/promote/qr-codes': typeof OrgSlugAdminPromoteQrCodesRoute
  '/$orgSlug/admin/promote/share-embed': typeof OrgSlugAdminPromoteShareEmbedRoute
  '/$orgSlug/admin/promote/sponsors': typeof OrgSlugAdminPromoteSponsorsRoute
  '/$orgSlug/admin/settings/billing': typeof OrgSlugAdminSettingsBillingRoute
  '/$orgSlug/admin/settings/branding': typeof OrgSlugAdminSettingsBrandingRoute
  '/$orgSlug/admin/settings/domains': typeof OrgSlugAdminSettingsDomainsRoute
  '/$orgSlug/admin/settings/faq': typeof OrgSlugAdminSettingsFaqRoute
  '/$orgSlug/admin/settings/quick-links': typeof OrgSlugAdminSettingsQuickLinksRoute
  '/$orgSlug/admin/settings/social-links': typeof OrgSlugAdminSettingsSocialLinksRoute
  '/$orgSlug/admin/settings/visitor-menu': typeof OrgSlugAdminSettingsVisitorMenuRoute
  '/superadmin/themes/base/$slug': typeof SuperadminThemesBaseSlugRoute
  '/$orgSlug/admin/map/$mapSlug/place-pois': typeof OrgSlugAdminMapMapSlugPlacePoisRoute
  '/$orgSlug/admin/map/$mapSlug/tags': typeof OrgSlugAdminMapMapSlugTagsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$mapSlug': typeof MapSlugRoute
  '/account': typeof AccountRoute
  '/create-org': typeof CreateOrgRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/help': typeof HelpRouteWithChildren
  '/join': typeof JoinRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/superadmin': typeof SuperadminRouteWithChildren
  '/$orgSlug/$mapSlug': typeof OrgSlugMapSlugRoute
  '/$orgSlug/admin': typeof OrgSlugAdminRouteWithChildren
  '/superadmin/a11y': typeof SuperadminA11yRoute
  '/superadmin/audit-log': typeof SuperadminAuditLogRouteWithChildren
  '/superadmin/engagement-reports': typeof SuperadminEngagementReportsRoute
  '/superadmin/feature-flags': typeof SuperadminFeatureFlagsRouteWithChildren
  '/superadmin/map-scanner': typeof SuperadminMapScannerRoute
  '/superadmin/onboarding': typeof SuperadminOnboardingRoute
  '/superadmin/orgs': typeof SuperadminOrgsRouteWithChildren
  '/superadmin/promote-assets': typeof SuperadminPromoteAssetsRoute
  '/superadmin/reports': typeof SuperadminReportsRoute
  '/superadmin/security-logs': typeof SuperadminSecurityLogsRouteWithChildren
  '/superadmin/support': typeof SuperadminSupportRoute
  '/superadmin/themes': typeof SuperadminThemesRouteWithChildren
  '/help/$section': typeof HelpSectionLazyRoute
  '/superadmin/': typeof SuperadminIndexRoute
  '/help/': typeof HelpIndexLazyRoute
  '/$orgSlug/admin/analytics': typeof OrgSlugAdminAnalyticsRoute
  '/$orgSlug/admin/announcements': typeof OrgSlugAdminAnnouncementsRoute
  '/$orgSlug/admin/audit-log': typeof OrgSlugAdminAuditLogRoute
  '/$orgSlug/admin/categories': typeof OrgSlugAdminCategoriesRoute
  '/$orgSlug/admin/curated-lists': typeof OrgSlugAdminCuratedListsRoute
  '/$orgSlug/admin/events': typeof OrgSlugAdminEventsRoute
  '/$orgSlug/admin/feedback': typeof OrgSlugAdminFeedbackRoute
  '/$orgSlug/admin/ingest': typeof OrgSlugAdminIngestRoute
  '/$orgSlug/admin/maps': typeof OrgSlugAdminMapsRoute
  '/$orgSlug/admin/notifications': typeof OrgSlugAdminNotificationsRoute
  '/$orgSlug/admin/pois': typeof OrgSlugAdminPoisRoute
  '/$orgSlug/admin/promote': typeof OrgSlugAdminPromoteRouteWithChildren
  '/$orgSlug/admin/qr-codes': typeof OrgSlugAdminQrCodesRoute
  '/$orgSlug/admin/settings': typeof OrgSlugAdminSettingsRouteWithChildren
  '/$orgSlug/admin/tags': typeof OrgSlugAdminTagsRoute
  '/$orgSlug/admin/team': typeof OrgSlugAdminTeamRoute
  '/superadmin/feature-flags/$flagId': typeof SuperadminFeatureFlagsFlagIdRoute
  '/superadmin/feature-flags/new': typeof SuperadminFeatureFlagsNewRoute
  '/superadmin/orgs/$orgId': typeof SuperadminOrgsOrgIdRoute
  '/superadmin/themes/$themeId': typeof SuperadminThemesThemeIdRoute
  '/$orgSlug/admin/': typeof OrgSlugAdminIndexRoute
  '/superadmin/audit-log/': typeof SuperadminAuditLogIndexRoute
  '/superadmin/feature-flags/': typeof SuperadminFeatureFlagsIndexRoute
  '/superadmin/orgs/': typeof SuperadminOrgsIndexRoute
  '/superadmin/security-logs/': typeof SuperadminSecurityLogsIndexRoute
  '/$orgSlug/admin/map/$mapSlug': typeof OrgSlugAdminMapMapSlugRouteWithChildren
  '/$orgSlug/admin/promote/assets': typeof OrgSlugAdminPromoteAssetsRoute
  '/$orgSlug/admin/promote/guides': typeof OrgSlugAdminPromoteGuidesRoute
  '/$orgSlug/admin/promote/marketing': typeof OrgSlugAdminPromoteMarketingRoute
  '/$orgSlug/admin/promote/qr-codes': typeof OrgSlugAdminPromoteQrCodesRoute
  '/$orgSlug/admin/promote/share-embed': typeof OrgSlugAdminPromoteShareEmbedRoute
  '/$orgSlug/admin/promote/sponsors': typeof OrgSlugAdminPromoteSponsorsRoute
  '/$orgSlug/admin/settings/billing': typeof OrgSlugAdminSettingsBillingRoute
  '/$orgSlug/admin/settings/branding': typeof OrgSlugAdminSettingsBrandingRoute
  '/$orgSlug/admin/settings/domains': typeof OrgSlugAdminSettingsDomainsRoute
  '/$orgSlug/admin/settings/faq': typeof OrgSlugAdminSettingsFaqRoute
  '/$orgSlug/admin/settings/quick-links': typeof OrgSlugAdminSettingsQuickLinksRoute
  '/$orgSlug/admin/settings/social-links': typeof OrgSlugAdminSettingsSocialLinksRoute
  '/$orgSlug/admin/settings/visitor-menu': typeof OrgSlugAdminSettingsVisitorMenuRoute
  '/superadmin/themes/base/$slug': typeof SuperadminThemesBaseSlugRoute
  '/$orgSlug/admin/map/$mapSlug/place-pois': typeof OrgSlugAdminMapMapSlugPlacePoisRoute
  '/$orgSlug/admin/map/$mapSlug/tags': typeof OrgSlugAdminMapMapSlugTagsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$mapSlug'
    | '/account'
    | '/create-org'
    | '/forgot-password'
    | '/help'
    | '/join'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/superadmin'
    | '/$orgSlug/$mapSlug'
    | '/$orgSlug/admin'
    | '/superadmin/a11y'
    | '/superadmin/audit-log'
    | '/superadmin/engagement-reports'
    | '/superadmin/feature-flags'
    | '/superadmin/map-scanner'
    | '/superadmin/onboarding'
    | '/superadmin/orgs'
    | '/superadmin/promote-assets'
    | '/superadmin/reports'
    | '/superadmin/security-logs'
    | '/superadmin/support'
    | '/superadmin/themes'
    | '/help/$section'
    | '/superadmin/'
    | '/help/'
    | '/$orgSlug/admin/analytics'
    | '/$orgSlug/admin/announcements'
    | '/$orgSlug/admin/audit-log'
    | '/$orgSlug/admin/categories'
    | '/$orgSlug/admin/curated-lists'
    | '/$orgSlug/admin/events'
    | '/$orgSlug/admin/feedback'
    | '/$orgSlug/admin/ingest'
    | '/$orgSlug/admin/maps'
    | '/$orgSlug/admin/notifications'
    | '/$orgSlug/admin/pois'
    | '/$orgSlug/admin/promote'
    | '/$orgSlug/admin/qr-codes'
    | '/$orgSlug/admin/settings'
    | '/$orgSlug/admin/tags'
    | '/$orgSlug/admin/team'
    | '/superadmin/feature-flags/$flagId'
    | '/superadmin/feature-flags/new'
    | '/superadmin/orgs/$orgId'
    | '/superadmin/themes/$themeId'
    | '/$orgSlug/admin/'
    | '/superadmin/audit-log/'
    | '/superadmin/feature-flags/'
    | '/superadmin/orgs/'
    | '/superadmin/security-logs/'
    | '/$orgSlug/admin/map/$mapSlug'
    | '/$orgSlug/admin/promote/assets'
    | '/$orgSlug/admin/promote/guides'
    | '/$orgSlug/admin/promote/marketing'
    | '/$orgSlug/admin/promote/qr-codes'
    | '/$orgSlug/admin/promote/share-embed'
    | '/$orgSlug/admin/promote/sponsors'
    | '/$orgSlug/admin/settings/billing'
    | '/$orgSlug/admin/settings/branding'
    | '/$orgSlug/admin/settings/domains'
    | '/$orgSlug/admin/settings/faq'
    | '/$orgSlug/admin/settings/quick-links'
    | '/$orgSlug/admin/settings/social-links'
    | '/$orgSlug/admin/settings/visitor-menu'
    | '/superadmin/themes/base/$slug'
    | '/$orgSlug/admin/map/$mapSlug/place-pois'
    | '/$orgSlug/admin/map/$mapSlug/tags'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$mapSlug'
    | '/account'
    | '/create-org'
    | '/forgot-password'
    | '/join'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/$orgSlug/$mapSlug'
    | '/superadmin/a11y'
    | '/superadmin/engagement-reports'
    | '/superadmin/map-scanner'
    | '/superadmin/onboarding'
    | '/superadmin/promote-assets'
    | '/superadmin/reports'
    | '/superadmin/support'
    | '/superadmin/themes'
    | '/help/$section'
    | '/superadmin'
    | '/help'
    | '/$orgSlug/admin/analytics'
    | '/$orgSlug/admin/announcements'
    | '/$orgSlug/admin/audit-log'
    | '/$orgSlug/admin/categories'
    | '/$orgSlug/admin/curated-lists'
    | '/$orgSlug/admin/events'
    | '/$orgSlug/admin/feedback'
    | '/$orgSlug/admin/ingest'
    | '/$orgSlug/admin/maps'
    | '/$orgSlug/admin/notifications'
    | '/$orgSlug/admin/pois'
    | '/$orgSlug/admin/promote'
    | '/$orgSlug/admin/qr-codes'
    | '/$orgSlug/admin/settings'
    | '/$orgSlug/admin/tags'
    | '/$orgSlug/admin/team'
    | '/superadmin/feature-flags/$flagId'
    | '/superadmin/feature-flags/new'
    | '/superadmin/orgs/$orgId'
    | '/superadmin/themes/$themeId'
    | '/$orgSlug/admin'
    | '/superadmin/audit-log'
    | '/superadmin/feature-flags'
    | '/superadmin/orgs'
    | '/superadmin/security-logs'
    | '/$orgSlug/admin/map/$mapSlug'
    | '/$orgSlug/admin/promote/assets'
    | '/$orgSlug/admin/promote/guides'
    | '/$orgSlug/admin/promote/marketing'
    | '/$orgSlug/admin/promote/qr-codes'
    | '/$orgSlug/admin/promote/share-embed'
    | '/$orgSlug/admin/promote/sponsors'
    | '/$orgSlug/admin/settings/billing'
    | '/$orgSlug/admin/settings/branding'
    | '/$orgSlug/admin/settings/domains'
    | '/$orgSlug/admin/settings/faq'
    | '/$orgSlug/admin/settings/quick-links'
    | '/$orgSlug/admin/settings/social-links'
    | '/$orgSlug/admin/settings/visitor-menu'
    | '/superadmin/themes/base/$slug'
    | '/$orgSlug/admin/map/$mapSlug/place-pois'
    | '/$orgSlug/admin/map/$mapSlug/tags'
  id:
    | '__root__'
    | '/'
    | '/$mapSlug'
    | '/account'
    | '/create-org'
    | '/forgot-password'
    | '/help'
    | '/join'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/superadmin'
    | '/$orgSlug/$mapSlug'
    | '/$orgSlug/admin'
    | '/superadmin/a11y'
    | '/superadmin/audit-log'
    | '/superadmin/engagement-reports'
    | '/superadmin/feature-flags'
    | '/superadmin/map-scanner'
    | '/superadmin/onboarding'
    | '/superadmin/orgs'
    | '/superadmin/promote-assets'
    | '/superadmin/reports'
    | '/superadmin/security-logs'
    | '/superadmin/support'
    | '/superadmin/themes'
    | '/help/$section'
    | '/superadmin/'
    | '/help/'
    | '/$orgSlug/admin/analytics'
    | '/$orgSlug/admin/announcements'
    | '/$orgSlug/admin/audit-log'
    | '/$orgSlug/admin/categories'
    | '/$orgSlug/admin/curated-lists'
    | '/$orgSlug/admin/events'
    | '/$orgSlug/admin/feedback'
    | '/$orgSlug/admin/ingest'
    | '/$orgSlug/admin/maps'
    | '/$orgSlug/admin/notifications'
    | '/$orgSlug/admin/pois'
    | '/$orgSlug/admin/promote'
    | '/$orgSlug/admin/qr-codes'
    | '/$orgSlug/admin/settings'
    | '/$orgSlug/admin/tags'
    | '/$orgSlug/admin/team'
    | '/superadmin/feature-flags/$flagId'
    | '/superadmin/feature-flags/new'
    | '/superadmin/orgs/$orgId'
    | '/superadmin/themes/$themeId'
    | '/$orgSlug/admin/'
    | '/superadmin/audit-log/'
    | '/superadmin/feature-flags/'
    | '/superadmin/orgs/'
    | '/superadmin/security-logs/'
    | '/$orgSlug/admin/map/$mapSlug'
    | '/$orgSlug/admin/promote/assets'
    | '/$orgSlug/admin/promote/guides'
    | '/$orgSlug/admin/promote/marketing'
    | '/$orgSlug/admin/promote/qr-codes'
    | '/$orgSlug/admin/promote/share-embed'
    | '/$orgSlug/admin/promote/sponsors'
    | '/$orgSlug/admin/settings/billing'
    | '/$orgSlug/admin/settings/branding'
    | '/$orgSlug/admin/settings/domains'
    | '/$orgSlug/admin/settings/faq'
    | '/$orgSlug/admin/settings/quick-links'
    | '/$orgSlug/admin/settings/social-links'
    | '/$orgSlug/admin/settings/visitor-menu'
    | '/superadmin/themes/base/$slug'
    | '/$orgSlug/admin/map/$mapSlug/place-pois'
    | '/$orgSlug/admin/map/$mapSlug/tags'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  MapSlugRoute: typeof MapSlugRoute
  AccountRoute: typeof AccountRoute
  CreateOrgRoute: typeof CreateOrgRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  HelpRoute: typeof HelpRouteWithChildren
  JoinRoute: typeof JoinRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  SuperadminRoute: typeof SuperadminRouteWithChildren
  OrgSlugMapSlugRoute: typeof OrgSlugMapSlugRoute
  OrgSlugAdminRoute: typeof OrgSlugAdminRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/superadmin': {
      id: '/superadmin'
      path: '/superadmin'
      fullPath: '/superadmin'
      preLoaderRoute: typeof SuperadminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join': {
      id: '/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof JoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help': {
      id: '/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof HelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create-org': {
      id: '/create-org'
      path: '/create-org'
      fullPath: '/create-org'
      preLoaderRoute: typeof CreateOrgRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$mapSlug': {
      id: '/$mapSlug'
      path: '/$mapSlug'
      fullPath: '/$mapSlug'
      preLoaderRoute: typeof MapSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help/': {
      id: '/help/'
      path: '/'
      fullPath: '/help/'
      preLoaderRoute: typeof HelpIndexLazyRouteImport
      parentRoute: typeof HelpRoute
    }
    '/superadmin/': {
      id: '/superadmin/'
      path: '/'
      fullPath: '/superadmin/'
      preLoaderRoute: typeof SuperadminIndexRouteImport
      parentRoute: typeof SuperadminRoute
    }
    '/help/$section': {
      id: '/help/$section'
      path: '/$section'
      fullPath: '/help/$section'
      preLoaderRoute: typeof HelpSectionLazyRouteImport
      parentRoute: typeof HelpRoute
    }
    '/superadmin/themes': {
      id: '/superadmin/themes'
      path: '/themes'
      fullPath: '/superadmin/themes'
      preLoaderRoute: typeof SuperadminThemesRouteImport
      parentRoute: typeof SuperadminRoute
    }
    '/superadmin/support': {
      id: '/superadmin/support'
      path: '/support'
      fullPath: '/superadmin/support'
      preLoaderRoute: typeof SuperadminSupportRouteImport
      parentRoute: typeof SuperadminRoute
    }
    '/superadmin/security-logs': {
      id: '/superadmin/security-logs'
      path: '/security-logs'
      fullPath: '/superadmin/security-logs'
      preLoaderRoute: typeof SuperadminSecurityLogsRouteImport
      parentRoute: typeof SuperadminRoute
    }
    '/superadmin/reports': {
      id: '/superadmin/reports'
      path: '/reports'
      fullPath: '/superadmin/reports'
      preLoaderRoute: typeof SuperadminReportsRouteImport
      parentRoute: typeof SuperadminRoute
    }
    '/superadmin/promote-assets': {
      id: '/superadmin/promote-assets'
      path: '/promote-assets'
      fullPath: '/superadmin/promote-assets'
      preLoaderRoute: typeof SuperadminPromoteAssetsRouteImport
      parentRoute: typeof SuperadminRoute
    }
    '/superadmin/orgs': {
      id: '/superadmin/orgs'
      path: '/orgs'
      fullPath: '/superadmin/orgs'
      preLoaderRoute: typeof SuperadminOrgsRouteImport
      parentRoute: typeof SuperadminRoute
    }
    '/superadmin/onboarding': {
      id: '/superadmin/onboarding'
      path: '/onboarding'
      fullPath: '/superadmin/onboarding'
      preLoaderRoute: typeof SuperadminOnboardingRouteImport
      parentRoute: typeof SuperadminRoute
    }
    '/superadmin/map-scanner': {
      id: '/superadmin/map-scanner'
      path: '/map-scanner'
      fullPath: '/superadmin/map-scanner'
      preLoaderRoute: typeof SuperadminMapScannerRouteImport
      parentRoute: typeof SuperadminRoute
    }
    '/superadmin/feature-flags': {
      id: '/superadmin/feature-flags'
      path: '/feature-flags'
      fullPath: '/superadmin/feature-flags'
      preLoaderRoute: typeof SuperadminFeatureFlagsRouteImport
      parentRoute: typeof SuperadminRoute
    }
    '/superadmin/engagement-reports': {
      id: '/superadmin/engagement-reports'
      path: '/engagement-reports'
      fullPath: '/superadmin/engagement-reports'
      preLoaderRoute: typeof SuperadminEngagementReportsRouteImport
      parentRoute: typeof SuperadminRoute
    }
    '/superadmin/audit-log': {
      id: '/superadmin/audit-log'
      path: '/audit-log'
      fullPath: '/superadmin/audit-log'
      preLoaderRoute: typeof SuperadminAuditLogRouteImport
      parentRoute: typeof SuperadminRoute
    }
    '/superadmin/a11y': {
      id: '/superadmin/a11y'
      path: '/a11y'
      fullPath: '/superadmin/a11y'
      preLoaderRoute: typeof SuperadminA11yRouteImport
      parentRoute: typeof SuperadminRoute
    }
    '/$orgSlug/admin': {
      id: '/$orgSlug/admin'
      path: '/$orgSlug/admin'
      fullPath: '/$orgSlug/admin'
      preLoaderRoute: typeof OrgSlugAdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$orgSlug/$mapSlug': {
      id: '/$orgSlug/$mapSlug'
      path: '/$orgSlug/$mapSlug'
      fullPath: '/$orgSlug/$mapSlug'
      preLoaderRoute: typeof OrgSlugMapSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/superadmin/security-logs/': {
      id: '/superadmin/security-logs/'
      path: '/'
      fullPath: '/superadmin/security-logs/'
      preLoaderRoute: typeof SuperadminSecurityLogsIndexRouteImport
      parentRoute: typeof SuperadminSecurityLogsRoute
    }
    '/superadmin/orgs/': {
      id: '/superadmin/orgs/'
      path: '/'
      fullPath: '/superadmin/orgs/'
      preLoaderRoute: typeof SuperadminOrgsIndexRouteImport
      parentRoute: typeof SuperadminOrgsRoute
    }
    '/superadmin/feature-flags/': {
      id: '/superadmin/feature-flags/'
      path: '/'
      fullPath: '/superadmin/feature-flags/'
      preLoaderRoute: typeof SuperadminFeatureFlagsIndexRouteImport
      parentRoute: typeof SuperadminFeatureFlagsRoute
    }
    '/superadmin/audit-log/': {
      id: '/superadmin/audit-log/'
      path: '/'
      fullPath: '/superadmin/audit-log/'
      preLoaderRoute: typeof SuperadminAuditLogIndexRouteImport
      parentRoute: typeof SuperadminAuditLogRoute
    }
    '/$orgSlug/admin/': {
      id: '/$orgSlug/admin/'
      path: '/'
      fullPath: '/$orgSlug/admin/'
      preLoaderRoute: typeof OrgSlugAdminIndexRouteImport
      parentRoute: typeof OrgSlugAdminRoute
    }
    '/superadmin/themes/$themeId': {
      id: '/superadmin/themes/$themeId'
      path: '/$themeId'
      fullPath: '/superadmin/themes/$themeId'
      preLoaderRoute: typeof SuperadminThemesThemeIdRouteImport
      parentRoute: typeof SuperadminThemesRoute
    }
    '/superadmin/orgs/$orgId': {
      id: '/superadmin/orgs/$orgId'
      path: '/$orgId'
      fullPath: '/superadmin/orgs/$orgId'
      preLoaderRoute: typeof SuperadminOrgsOrgIdRouteImport
      parentRoute: typeof SuperadminOrgsRoute
    }
    '/superadmin/feature-flags/new': {
      id: '/superadmin/feature-flags/new'
      path: '/new'
      fullPath: '/superadmin/feature-flags/new'
      preLoaderRoute: typeof SuperadminFeatureFlagsNewRouteImport
      parentRoute: typeof SuperadminFeatureFlagsRoute
    }
    '/superadmin/feature-flags/$flagId': {
      id: '/superadmin/feature-flags/$flagId'
      path: '/$flagId'
      fullPath: '/superadmin/feature-flags/$flagId'
      preLoaderRoute: typeof SuperadminFeatureFlagsFlagIdRouteImport
      parentRoute: typeof SuperadminFeatureFlagsRoute
    }
    '/$orgSlug/admin/team': {
      id: '/$orgSlug/admin/team'
      path: '/team'
      fullPath: '/$orgSlug/admin/team'
      preLoaderRoute: typeof OrgSlugAdminTeamRouteImport
      parentRoute: typeof OrgSlugAdminRoute
    }
    '/$orgSlug/admin/tags': {
      id: '/$orgSlug/admin/tags'
      path: '/tags'
      fullPath: '/$orgSlug/admin/tags'
      preLoaderRoute: typeof OrgSlugAdminTagsRouteImport
      parentRoute: typeof OrgSlugAdminRoute
    }
    '/$orgSlug/admin/settings': {
      id: '/$orgSlug/admin/settings'
      path: '/settings'
      fullPath: '/$orgSlug/admin/settings'
      preLoaderRoute: typeof OrgSlugAdminSettingsRouteImport
      parentRoute: typeof OrgSlugAdminRoute
    }
    '/$orgSlug/admin/qr-codes': {
      id: '/$orgSlug/admin/qr-codes'
      path: '/qr-codes'
      fullPath: '/$orgSlug/admin/qr-codes'
      preLoaderRoute: typeof OrgSlugAdminQrCodesRouteImport
      parentRoute: typeof OrgSlugAdminRoute
    }
    '/$orgSlug/admin/promote': {
      id: '/$orgSlug/admin/promote'
      path: '/promote'
      fullPath: '/$orgSlug/admin/promote'
      preLoaderRoute: typeof OrgSlugAdminPromoteRouteImport
      parentRoute: typeof OrgSlugAdminRoute
    }
    '/$orgSlug/admin/pois': {
      id: '/$orgSlug/admin/pois'
      path: '/pois'
      fullPath: '/$orgSlug/admin/pois'
      preLoaderRoute: typeof OrgSlugAdminPoisRouteImport
      parentRoute: typeof OrgSlugAdminRoute
    }
    '/$orgSlug/admin/notifications': {
      id: '/$orgSlug/admin/notifications'
      path: '/notifications'
      fullPath: '/$orgSlug/admin/notifications'
      preLoaderRoute: typeof OrgSlugAdminNotificationsRouteImport
      parentRoute: typeof OrgSlugAdminRoute
    }
    '/$orgSlug/admin/maps': {
      id: '/$orgSlug/admin/maps'
      path: '/maps'
      fullPath: '/$orgSlug/admin/maps'
      preLoaderRoute: typeof OrgSlugAdminMapsRouteImport
      parentRoute: typeof OrgSlugAdminRoute
    }
    '/$orgSlug/admin/ingest': {
      id: '/$orgSlug/admin/ingest'
      path: '/ingest'
      fullPath: '/$orgSlug/admin/ingest'
      preLoaderRoute: typeof OrgSlugAdminIngestRouteImport
      parentRoute: typeof OrgSlugAdminRoute
    }
    '/$orgSlug/admin/feedback': {
      id: '/$orgSlug/admin/feedback'
      path: '/feedback'
      fullPath: '/$orgSlug/admin/feedback'
      preLoaderRoute: typeof OrgSlugAdminFeedbackRouteImport
      parentRoute: typeof OrgSlugAdminRoute
    }
    '/$orgSlug/admin/events': {
      id: '/$orgSlug/admin/events'
      path: '/events'
      fullPath: '/$orgSlug/admin/events'
      preLoaderRoute: typeof OrgSlugAdminEventsRouteImport
      parentRoute: typeof OrgSlugAdminRoute
    }
    '/$orgSlug/admin/curated-lists': {
      id: '/$orgSlug/admin/curated-lists'
      path: '/curated-lists'
      fullPath: '/$orgSlug/admin/curated-lists'
      preLoaderRoute: typeof OrgSlugAdminCuratedListsRouteImport
      parentRoute: typeof OrgSlugAdminRoute
    }
    '/$orgSlug/admin/categories': {
      id: '/$orgSlug/admin/categories'
      path: '/categories'
      fullPath: '/$orgSlug/admin/categories'
      preLoaderRoute: typeof OrgSlugAdminCategoriesRouteImport
      parentRoute: typeof OrgSlugAdminRoute
    }
    '/$orgSlug/admin/audit-log': {
      id: '/$orgSlug/admin/audit-log'
      path: '/audit-log'
      fullPath: '/$orgSlug/admin/audit-log'
      preLoaderRoute: typeof OrgSlugAdminAuditLogRouteImport
      parentRoute: typeof OrgSlugAdminRoute
    }
    '/$orgSlug/admin/announcements': {
      id: '/$orgSlug/admin/announcements'
      path: '/announcements'
      fullPath: '/$orgSlug/admin/announcements'
      preLoaderRoute: typeof OrgSlugAdminAnnouncementsRouteImport
      parentRoute: typeof OrgSlugAdminRoute
    }
    '/$orgSlug/admin/analytics': {
      id: '/$orgSlug/admin/analytics'
      path: '/analytics'
      fullPath: '/$orgSlug/admin/analytics'
      preLoaderRoute: typeof OrgSlugAdminAnalyticsRouteImport
      parentRoute: typeof OrgSlugAdminRoute
    }
    '/superadmin/themes/base/$slug': {
      id: '/superadmin/themes/base/$slug'
      path: '/base/$slug'
      fullPath: '/superadmin/themes/base/$slug'
      preLoaderRoute: typeof SuperadminThemesBaseSlugRouteImport
      parentRoute: typeof SuperadminThemesRoute
    }
    '/$orgSlug/admin/settings/visitor-menu': {
      id: '/$orgSlug/admin/settings/visitor-menu'
      path: '/visitor-menu'
      fullPath: '/$orgSlug/admin/settings/visitor-menu'
      preLoaderRoute: typeof OrgSlugAdminSettingsVisitorMenuRouteImport
      parentRoute: typeof OrgSlugAdminSettingsRoute
    }
    '/$orgSlug/admin/settings/social-links': {
      id: '/$orgSlug/admin/settings/social-links'
      path: '/social-links'
      fullPath: '/$orgSlug/admin/settings/social-links'
      preLoaderRoute: typeof OrgSlugAdminSettingsSocialLinksRouteImport
      parentRoute: typeof OrgSlugAdminSettingsRoute
    }
    '/$orgSlug/admin/settings/quick-links': {
      id: '/$orgSlug/admin/settings/quick-links'
      path: '/quick-links'
      fullPath: '/$orgSlug/admin/settings/quick-links'
      preLoaderRoute: typeof OrgSlugAdminSettingsQuickLinksRouteImport
      parentRoute: typeof OrgSlugAdminSettingsRoute
    }
    '/$orgSlug/admin/settings/faq': {
      id: '/$orgSlug/admin/settings/faq'
      path: '/faq'
      fullPath: '/$orgSlug/admin/settings/faq'
      preLoaderRoute: typeof OrgSlugAdminSettingsFaqRouteImport
      parentRoute: typeof OrgSlugAdminSettingsRoute
    }
    '/$orgSlug/admin/settings/domains': {
      id: '/$orgSlug/admin/settings/domains'
      path: '/domains'
      fullPath: '/$orgSlug/admin/settings/domains'
      preLoaderRoute: typeof OrgSlugAdminSettingsDomainsRouteImport
      parentRoute: typeof OrgSlugAdminSettingsRoute
    }
    '/$orgSlug/admin/settings/branding': {
      id: '/$orgSlug/admin/settings/branding'
      path: '/branding'
      fullPath: '/$orgSlug/admin/settings/branding'
      preLoaderRoute: typeof OrgSlugAdminSettingsBrandingRouteImport
      parentRoute: typeof OrgSlugAdminSettingsRoute
    }
    '/$orgSlug/admin/settings/billing': {
      id: '/$orgSlug/admin/settings/billing'
      path: '/billing'
      fullPath: '/$orgSlug/admin/settings/billing'
      preLoaderRoute: typeof OrgSlugAdminSettingsBillingRouteImport
      parentRoute: typeof OrgSlugAdminSettingsRoute
    }
    '/$orgSlug/admin/promote/sponsors': {
      id: '/$orgSlug/admin/promote/sponsors'
      path: '/sponsors'
      fullPath: '/$orgSlug/admin/promote/sponsors'
      preLoaderRoute: typeof OrgSlugAdminPromoteSponsorsRouteImport
      parentRoute: typeof OrgSlugAdminPromoteRoute
    }
    '/$orgSlug/admin/promote/share-embed': {
      id: '/$orgSlug/admin/promote/share-embed'
      path: '/share-embed'
      fullPath: '/$orgSlug/admin/promote/share-embed'
      preLoaderRoute: typeof OrgSlugAdminPromoteShareEmbedRouteImport
      parentRoute: typeof OrgSlugAdminPromoteRoute
    }
    '/$orgSlug/admin/promote/qr-codes': {
      id: '/$orgSlug/admin/promote/qr-codes'
      path: '/qr-codes'
      fullPath: '/$orgSlug/admin/promote/qr-codes'
      preLoaderRoute: typeof OrgSlugAdminPromoteQrCodesRouteImport
      parentRoute: typeof OrgSlugAdminPromoteRoute
    }
    '/$orgSlug/admin/promote/marketing': {
      id: '/$orgSlug/admin/promote/marketing'
      path: '/marketing'
      fullPath: '/$orgSlug/admin/promote/marketing'
      preLoaderRoute: typeof OrgSlugAdminPromoteMarketingRouteImport
      parentRoute: typeof OrgSlugAdminPromoteRoute
    }
    '/$orgSlug/admin/promote/guides': {
      id: '/$orgSlug/admin/promote/guides'
      path: '/guides'
      fullPath: '/$orgSlug/admin/promote/guides'
      preLoaderRoute: typeof OrgSlugAdminPromoteGuidesRouteImport
      parentRoute: typeof OrgSlugAdminPromoteRoute
    }
    '/$orgSlug/admin/promote/assets': {
      id: '/$orgSlug/admin/promote/assets'
      path: '/assets'
      fullPath: '/$orgSlug/admin/promote/assets'
      preLoaderRoute: typeof OrgSlugAdminPromoteAssetsRouteImport
      parentRoute: typeof OrgSlugAdminPromoteRoute
    }
    '/$orgSlug/admin/map/$mapSlug': {
      id: '/$orgSlug/admin/map/$mapSlug'
      path: '/map/$mapSlug'
      fullPath: '/$orgSlug/admin/map/$mapSlug'
      preLoaderRoute: typeof OrgSlugAdminMapMapSlugRouteImport
      parentRoute: typeof OrgSlugAdminRoute
    }
    '/$orgSlug/admin/map/$mapSlug/tags': {
      id: '/$orgSlug/admin/map/$mapSlug/tags'
      path: '/tags'
      fullPath: '/$orgSlug/admin/map/$mapSlug/tags'
      preLoaderRoute: typeof OrgSlugAdminMapMapSlugTagsRouteImport
      parentRoute: typeof OrgSlugAdminMapMapSlugRoute
    }
    '/$orgSlug/admin/map/$mapSlug/place-pois': {
      id: '/$orgSlug/admin/map/$mapSlug/place-pois'
      path: '/place-pois'
      fullPath: '/$orgSlug/admin/map/$mapSlug/place-pois'
      preLoaderRoute: typeof OrgSlugAdminMapMapSlugPlacePoisRouteImport
      parentRoute: typeof OrgSlugAdminMapMapSlugRoute
    }
  }
}

interface HelpRouteChildren {
  HelpSectionLazyRoute: typeof HelpSectionLazyRoute
  HelpIndexLazyRoute: typeof HelpIndexLazyRoute
}

const HelpRouteChildren: HelpRouteChildren = {
  HelpSectionLazyRoute: HelpSectionLazyRoute,
  HelpIndexLazyRoute: HelpIndexLazyRoute,
}

const HelpRouteWithChildren = HelpRoute._addFileChildren(HelpRouteChildren)

interface SuperadminAuditLogRouteChildren {
  SuperadminAuditLogIndexRoute: typeof SuperadminAuditLogIndexRoute
}

const SuperadminAuditLogRouteChildren: SuperadminAuditLogRouteChildren = {
  SuperadminAuditLogIndexRoute: SuperadminAuditLogIndexRoute,
}

const SuperadminAuditLogRouteWithChildren =
  SuperadminAuditLogRoute._addFileChildren(SuperadminAuditLogRouteChildren)

interface SuperadminFeatureFlagsRouteChildren {
  SuperadminFeatureFlagsFlagIdRoute: typeof SuperadminFeatureFlagsFlagIdRoute
  SuperadminFeatureFlagsNewRoute: typeof SuperadminFeatureFlagsNewRoute
  SuperadminFeatureFlagsIndexRoute: typeof SuperadminFeatureFlagsIndexRoute
}

const SuperadminFeatureFlagsRouteChildren: SuperadminFeatureFlagsRouteChildren =
  {
    SuperadminFeatureFlagsFlagIdRoute: SuperadminFeatureFlagsFlagIdRoute,
    SuperadminFeatureFlagsNewRoute: SuperadminFeatureFlagsNewRoute,
    SuperadminFeatureFlagsIndexRoute: SuperadminFeatureFlagsIndexRoute,
  }

const SuperadminFeatureFlagsRouteWithChildren =
  SuperadminFeatureFlagsRoute._addFileChildren(
    SuperadminFeatureFlagsRouteChildren,
  )

interface SuperadminOrgsRouteChildren {
  SuperadminOrgsOrgIdRoute: typeof SuperadminOrgsOrgIdRoute
  SuperadminOrgsIndexRoute: typeof SuperadminOrgsIndexRoute
}

const SuperadminOrgsRouteChildren: SuperadminOrgsRouteChildren = {
  SuperadminOrgsOrgIdRoute: SuperadminOrgsOrgIdRoute,
  SuperadminOrgsIndexRoute: SuperadminOrgsIndexRoute,
}

const SuperadminOrgsRouteWithChildren = SuperadminOrgsRoute._addFileChildren(
  SuperadminOrgsRouteChildren,
)

interface SuperadminSecurityLogsRouteChildren {
  SuperadminSecurityLogsIndexRoute: typeof SuperadminSecurityLogsIndexRoute
}

const SuperadminSecurityLogsRouteChildren: SuperadminSecurityLogsRouteChildren =
  {
    SuperadminSecurityLogsIndexRoute: SuperadminSecurityLogsIndexRoute,
  }

const SuperadminSecurityLogsRouteWithChildren =
  SuperadminSecurityLogsRoute._addFileChildren(
    SuperadminSecurityLogsRouteChildren,
  )

interface SuperadminThemesRouteChildren {
  SuperadminThemesThemeIdRoute: typeof SuperadminThemesThemeIdRoute
  SuperadminThemesBaseSlugRoute: typeof SuperadminThemesBaseSlugRoute
}

const SuperadminThemesRouteChildren: SuperadminThemesRouteChildren = {
  SuperadminThemesThemeIdRoute: SuperadminThemesThemeIdRoute,
  SuperadminThemesBaseSlugRoute: SuperadminThemesBaseSlugRoute,
}

const SuperadminThemesRouteWithChildren =
  SuperadminThemesRoute._addFileChildren(SuperadminThemesRouteChildren)

interface SuperadminRouteChildren {
  SuperadminA11yRoute: typeof SuperadminA11yRoute
  SuperadminAuditLogRoute: typeof SuperadminAuditLogRouteWithChildren
  SuperadminEngagementReportsRoute: typeof SuperadminEngagementReportsRoute
  SuperadminFeatureFlagsRoute: typeof SuperadminFeatureFlagsRouteWithChildren
  SuperadminMapScannerRoute: typeof SuperadminMapScannerRoute
  SuperadminOnboardingRoute: typeof SuperadminOnboardingRoute
  SuperadminOrgsRoute: typeof SuperadminOrgsRouteWithChildren
  SuperadminPromoteAssetsRoute: typeof SuperadminPromoteAssetsRoute
  SuperadminReportsRoute: typeof SuperadminReportsRoute
  SuperadminSecurityLogsRoute: typeof SuperadminSecurityLogsRouteWithChildren
  SuperadminSupportRoute: typeof SuperadminSupportRoute
  SuperadminThemesRoute: typeof SuperadminThemesRouteWithChildren
  SuperadminIndexRoute: typeof SuperadminIndexRoute
}

const SuperadminRouteChildren: SuperadminRouteChildren = {
  SuperadminA11yRoute: SuperadminA11yRoute,
  SuperadminAuditLogRoute: SuperadminAuditLogRouteWithChildren,
  SuperadminEngagementReportsRoute: SuperadminEngagementReportsRoute,
  SuperadminFeatureFlagsRoute: SuperadminFeatureFlagsRouteWithChildren,
  SuperadminMapScannerRoute: SuperadminMapScannerRoute,
  SuperadminOnboardingRoute: SuperadminOnboardingRoute,
  SuperadminOrgsRoute: SuperadminOrgsRouteWithChildren,
  SuperadminPromoteAssetsRoute: SuperadminPromoteAssetsRoute,
  SuperadminReportsRoute: SuperadminReportsRoute,
  SuperadminSecurityLogsRoute: SuperadminSecurityLogsRouteWithChildren,
  SuperadminSupportRoute: SuperadminSupportRoute,
  SuperadminThemesRoute: SuperadminThemesRouteWithChildren,
  SuperadminIndexRoute: SuperadminIndexRoute,
}

const SuperadminRouteWithChildren = SuperadminRoute._addFileChildren(
  SuperadminRouteChildren,
)

interface OrgSlugAdminPromoteRouteChildren {
  OrgSlugAdminPromoteAssetsRoute: typeof OrgSlugAdminPromoteAssetsRoute
  OrgSlugAdminPromoteGuidesRoute: typeof OrgSlugAdminPromoteGuidesRoute
  OrgSlugAdminPromoteMarketingRoute: typeof OrgSlugAdminPromoteMarketingRoute
  OrgSlugAdminPromoteQrCodesRoute: typeof OrgSlugAdminPromoteQrCodesRoute
  OrgSlugAdminPromoteShareEmbedRoute: typeof OrgSlugAdminPromoteShareEmbedRoute
  OrgSlugAdminPromoteSponsorsRoute: typeof OrgSlugAdminPromoteSponsorsRoute
}

const OrgSlugAdminPromoteRouteChildren: OrgSlugAdminPromoteRouteChildren = {
  OrgSlugAdminPromoteAssetsRoute: OrgSlugAdminPromoteAssetsRoute,
  OrgSlugAdminPromoteGuidesRoute: OrgSlugAdminPromoteGuidesRoute,
  OrgSlugAdminPromoteMarketingRoute: OrgSlugAdminPromoteMarketingRoute,
  OrgSlugAdminPromoteQrCodesRoute: OrgSlugAdminPromoteQrCodesRoute,
  OrgSlugAdminPromoteShareEmbedRoute: OrgSlugAdminPromoteShareEmbedRoute,
  OrgSlugAdminPromoteSponsorsRoute: OrgSlugAdminPromoteSponsorsRoute,
}

const OrgSlugAdminPromoteRouteWithChildren =
  OrgSlugAdminPromoteRoute._addFileChildren(OrgSlugAdminPromoteRouteChildren)

interface OrgSlugAdminSettingsRouteChildren {
  OrgSlugAdminSettingsBillingRoute: typeof OrgSlugAdminSettingsBillingRoute
  OrgSlugAdminSettingsBrandingRoute: typeof OrgSlugAdminSettingsBrandingRoute
  OrgSlugAdminSettingsDomainsRoute: typeof OrgSlugAdminSettingsDomainsRoute
  OrgSlugAdminSettingsFaqRoute: typeof OrgSlugAdminSettingsFaqRoute
  OrgSlugAdminSettingsQuickLinksRoute: typeof OrgSlugAdminSettingsQuickLinksRoute
  OrgSlugAdminSettingsSocialLinksRoute: typeof OrgSlugAdminSettingsSocialLinksRoute
  OrgSlugAdminSettingsVisitorMenuRoute: typeof OrgSlugAdminSettingsVisitorMenuRoute
}

const OrgSlugAdminSettingsRouteChildren: OrgSlugAdminSettingsRouteChildren = {
  OrgSlugAdminSettingsBillingRoute: OrgSlugAdminSettingsBillingRoute,
  OrgSlugAdminSettingsBrandingRoute: OrgSlugAdminSettingsBrandingRoute,
  OrgSlugAdminSettingsDomainsRoute: OrgSlugAdminSettingsDomainsRoute,
  OrgSlugAdminSettingsFaqRoute: OrgSlugAdminSettingsFaqRoute,
  OrgSlugAdminSettingsQuickLinksRoute: OrgSlugAdminSettingsQuickLinksRoute,
  OrgSlugAdminSettingsSocialLinksRoute: OrgSlugAdminSettingsSocialLinksRoute,
  OrgSlugAdminSettingsVisitorMenuRoute: OrgSlugAdminSettingsVisitorMenuRoute,
}

const OrgSlugAdminSettingsRouteWithChildren =
  OrgSlugAdminSettingsRoute._addFileChildren(OrgSlugAdminSettingsRouteChildren)

interface OrgSlugAdminMapMapSlugRouteChildren {
  OrgSlugAdminMapMapSlugPlacePoisRoute: typeof OrgSlugAdminMapMapSlugPlacePoisRoute
  OrgSlugAdminMapMapSlugTagsRoute: typeof OrgSlugAdminMapMapSlugTagsRoute
}

const OrgSlugAdminMapMapSlugRouteChildren: OrgSlugAdminMapMapSlugRouteChildren =
  {
    OrgSlugAdminMapMapSlugPlacePoisRoute: OrgSlugAdminMapMapSlugPlacePoisRoute,
    OrgSlugAdminMapMapSlugTagsRoute: OrgSlugAdminMapMapSlugTagsRoute,
  }

const OrgSlugAdminMapMapSlugRouteWithChildren =
  OrgSlugAdminMapMapSlugRoute._addFileChildren(
    OrgSlugAdminMapMapSlugRouteChildren,
  )

interface OrgSlugAdminRouteChildren {
  OrgSlugAdminAnalyticsRoute: typeof OrgSlugAdminAnalyticsRoute
  OrgSlugAdminAnnouncementsRoute: typeof OrgSlugAdminAnnouncementsRoute
  OrgSlugAdminAuditLogRoute: typeof OrgSlugAdminAuditLogRoute
  OrgSlugAdminCategoriesRoute: typeof OrgSlugAdminCategoriesRoute
  OrgSlugAdminCuratedListsRoute: typeof OrgSlugAdminCuratedListsRoute
  OrgSlugAdminEventsRoute: typeof OrgSlugAdminEventsRoute
  OrgSlugAdminFeedbackRoute: typeof OrgSlugAdminFeedbackRoute
  OrgSlugAdminIngestRoute: typeof OrgSlugAdminIngestRoute
  OrgSlugAdminMapsRoute: typeof OrgSlugAdminMapsRoute
  OrgSlugAdminNotificationsRoute: typeof OrgSlugAdminNotificationsRoute
  OrgSlugAdminPoisRoute: typeof OrgSlugAdminPoisRoute
  OrgSlugAdminPromoteRoute: typeof OrgSlugAdminPromoteRouteWithChildren
  OrgSlugAdminQrCodesRoute: typeof OrgSlugAdminQrCodesRoute
  OrgSlugAdminSettingsRoute: typeof OrgSlugAdminSettingsRouteWithChildren
  OrgSlugAdminTagsRoute: typeof OrgSlugAdminTagsRoute
  OrgSlugAdminTeamRoute: typeof OrgSlugAdminTeamRoute
  OrgSlugAdminIndexRoute: typeof OrgSlugAdminIndexRoute
  OrgSlugAdminMapMapSlugRoute: typeof OrgSlugAdminMapMapSlugRouteWithChildren
}

const OrgSlugAdminRouteChildren: OrgSlugAdminRouteChildren = {
  OrgSlugAdminAnalyticsRoute: OrgSlugAdminAnalyticsRoute,
  OrgSlugAdminAnnouncementsRoute: OrgSlugAdminAnnouncementsRoute,
  OrgSlugAdminAuditLogRoute: OrgSlugAdminAuditLogRoute,
  OrgSlugAdminCategoriesRoute: OrgSlugAdminCategoriesRoute,
  OrgSlugAdminCuratedListsRoute: OrgSlugAdminCuratedListsRoute,
  OrgSlugAdminEventsRoute: OrgSlugAdminEventsRoute,
  OrgSlugAdminFeedbackRoute: OrgSlugAdminFeedbackRoute,
  OrgSlugAdminIngestRoute: OrgSlugAdminIngestRoute,
  OrgSlugAdminMapsRoute: OrgSlugAdminMapsRoute,
  OrgSlugAdminNotificationsRoute: OrgSlugAdminNotificationsRoute,
  OrgSlugAdminPoisRoute: OrgSlugAdminPoisRoute,
  OrgSlugAdminPromoteRoute: OrgSlugAdminPromoteRouteWithChildren,
  OrgSlugAdminQrCodesRoute: OrgSlugAdminQrCodesRoute,
  OrgSlugAdminSettingsRoute: OrgSlugAdminSettingsRouteWithChildren,
  OrgSlugAdminTagsRoute: OrgSlugAdminTagsRoute,
  OrgSlugAdminTeamRoute: OrgSlugAdminTeamRoute,
  OrgSlugAdminIndexRoute: OrgSlugAdminIndexRoute,
  OrgSlugAdminMapMapSlugRoute: OrgSlugAdminMapMapSlugRouteWithChildren,
}

const OrgSlugAdminRouteWithChildren = OrgSlugAdminRoute._addFileChildren(
  OrgSlugAdminRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  MapSlugRoute: MapSlugRoute,
  AccountRoute: AccountRoute,
  CreateOrgRoute: CreateOrgRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  HelpRoute: HelpRouteWithChildren,
  JoinRoute: JoinRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  SuperadminRoute: SuperadminRouteWithChildren,
  OrgSlugMapSlugRoute: OrgSlugMapSlugRoute,
  OrgSlugAdminRoute: OrgSlugAdminRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
